export default __webpack_public_path__ + "static/media/img_demo_04.ba960627.jpg";